import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

import React from "react";
import { createRoot } from "react-dom/client";
import LoginApp from "./LoginApp";

const container = document.getElementById("auth-root");

if (!container) {
  throw new Error(
    'Could not find #auth-root element. Ensure the Twig template renders <div id="auth-root"></div>.'
  );
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <LoginApp />
  </React.StrictMode>
);
